import { lazy } from "react";
import AuthGuard from "routes/AuthGuard";
import Loadable from "routes/Loadable";
import AdminLayout from "components/layouts/adminLayout";

//cutting
const CuttingInvestment = Loadable(lazy(() => import("pages/cutting/Investment")));
const CuttingInvestmentReturn = Loadable(lazy(() => import("pages/cutting/InvestmentReturn")));
const Report = Loadable(lazy(() => import("pages/cutting/Report")));

const CuttingRoutes = {
  path: "cutting",
  element: (
    <AuthGuard>
      <AdminLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "investment",
      element: <CuttingInvestment />,
    },
    {
      path: "return-investment",
      element: <CuttingInvestmentReturn />,
    },
    {
      path: "report",
      element: <Report />,
    },
  ],
};

export default CuttingRoutes;
